import React, { ReactNode } from 'react';
import styles from './Section.module.scss';

export interface SectionProps {
  children: ReactNode;
  className?: string;
  background?: 'default' | 'surface' | 'primary';
  id?: string;
}

export const Section: React.FC<SectionProps> = ({
  children,
  className = '',
  background = 'default',
  id,
}) => {
  return (
    <section
      id={id}
      className={`${styles.section} ${styles[background]} ${className}`}
    >
      <div className="container">{children}</div>
    </section>
  );
};

export default Section;
